export function isPhoneNumber(value: string | null | undefined) {
  if (_isNil(value)) return false
  const regex = /^\(?([2-9][0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  return regex.test(value)
}

export function isEmail(value: string | null | undefined) {
  if (_isNil(value)) return false
  // http://emailregex.com/
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(value)
}

/**
 * Whether an answer-bag value counts as absent for a schema `MustHaveValue` /
 * `MustNotHaveValue` dependency rule.
 *
 * Mirrors `lacksValue` in ApplicationValidation, which is what decides whether a required field
 * is satisfied — the two must agree, or a field can be simultaneously "present" for a visibility
 * rule and "empty" for validation. Several answer-bag defaults coalesce to `''` rather than null
 * (`physicianPcpId`, `physicianName`), so the empty-string case is load-bearing.
 */
export function answerIsMissing(value: any) {
  return _isNil(value) || value === '' || (_isArray(value) && value.length < 1)
}
